// extracted by mini-css-extract-plugin
export default {"root":"AuthMethodTabs_root__evblh","tab":"AuthMethodTabs_tab__ZK904","tabActive":"AuthMethodTabs_tabActive__LIne9","tabOptional":"AuthMethodTabs_tabOptional__MY6lg"};